okeReviewsWidgetOnInit = function () {
    trimReviewsCount();
    moveAggregatedSection();
}

function trimReviewsCount() {
    var aggregateReviewCount = document.querySelector(".okeReviews-reviewsAggregate-summary-total");
    if (aggregateReviewCount) {
      aggregateReviewCount.innerText = aggregateReviewCount.innerText.replace( /^\D+/g, '');
    }
}

function moveAggregatedSection() {
    const writeAReviewButton = document.querySelector('.js-okeReviews-writeReview');
    const aggregateRating = document.querySelector('.okeReviews-reviewsAggregate-summary-rating');
    const reviewsControl = document.querySelector('.okeReviews-reviews-controls');
    if (writeAReviewButton) {
        // Insert WAR button into header
        if (writeAReviewButton && reviewsControl) {
            const reviewsControlSelect = reviewsControl.querySelector('.okeReviews-reviews-controls-select');
            reviewsControlSelect.insertAdjacentElement('afterbegin', writeAReviewButton);
        }
    }
    // Insert Aggregate Rating into header
    const reviewsCount = document.querySelector('.okeReviews-reviews-controls-reviewCount');
    if (aggregateRating && reviewsCount) {
        aggregateRating.insertAdjacentElement('beforeend', reviewsCount);
        reviewsControl.insertAdjacentElement('afterbegin', aggregateRating);
    }
}